<template>
 <div class="app-container">
    <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="80px" size="mini">
        <!-- <el-form-item label="审批人">
          <el-input  placeholder="审批人"></el-input>
        </el-form-item> -->
        <div class="formItemBox">
            <el-form-item label="捆包编号:" prop="cargoBarcode">
              <el-input placeholder="可支持多个" type="textarea" v-model="searchFrom.cargoBarcode"></el-input>
            </el-form-item>
              <el-form-item label="规格:" prop="specifications">
              <el-input placeholder="可支持多个" type="textarea" v-model="searchFrom.specifications"></el-input>
            </el-form-item>
                <el-form-item label="所在仓库:" prop="organizationId">
                <el-select  v-model="searchFrom.organizationId"  placeholder="">
                  <el-option v-for="val in warehouseList" :label="val.relTenantName" :value="val.relTenantCode" :key="val.relTenantCode"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="货物类型:" prop="productTypeId">
                <el-select  v-model="searchFrom.productTypeId"   placeholder="请选择">
                  <el-option v-for="item in productTypes" :label="item.show_name" :value="item.item_no" :key="item.item_no"></el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item label="提货中 :" prop="takeGoodStatus">
              <el-select v-model="searchFrom.takeGoodStatus" placeholder="请选择">
                <el-option  label="请选择" value="" ></el-option>
                <el-option  label="是" value="1" ></el-option>
                <el-option  label="否" value="2" ></el-option>
              </el-select>
            </el-form-item> -->
              <el-form-item label="品名:" prop="productName">
                <el-input  placeholder="" v-model="searchFrom.productName"></el-input>
              </el-form-item>
              <el-form-item label="重量:" prop="productName" class="zhong">
                <el-input  placeholder="" v-model="searchFrom.minWeight"></el-input>~
                <el-input  placeholder="" v-model="searchFrom.maxWeight"></el-input>
              </el-form-item>
              <el-form-item label="材质:" prop="model">
                <el-input  placeholder="" v-model="searchFrom.model"></el-input>
              </el-form-item>
              <!-- <el-form-item label="规格:" prop="specification">
              <el-input  placeholder="" v-model="searchFrom.specification"></el-input>
              </el-form-item> -->
                <el-form-item label="合同编号:" prop="contractNumber">
                <el-input  placeholder="" v-model="searchFrom.contractNumber"></el-input>
              </el-form-item>
              <el-form-item label="合约编号:" prop="agreementNumber">
                <el-input  placeholder="" v-model="searchFrom.agreementNumber"></el-input>
              </el-form-item>
              <el-form-item label="货位:" prop="cargoLocation">
               <el-input  placeholder="" v-model="searchFrom.cargoLocation"></el-input>
              </el-form-item>
              <el-form-item label="货物状态:" prop="status">
                <el-select  v-model="searchFrom.status" >
                  <el-option v-for="val in zt" :label="val.name" :value="val.val" :key="val.val"></el-option>
                </el-select>
              </el-form-item>
               <el-form-item label="入库时间:" prop="instockDate">
                    <el-date-picker
                      v-model="searchFrom.instockDate"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      type="datetimerange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                    ></el-date-picker>
                  </el-form-item>
        </div>

       <div class="searchBtnBox">
         <el-form-item btnCode="004P000B000"  v-if="btnFlg[0]">
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item btnCode="004P000B001"  v-if="btnFlg[1]">
            <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
          <el-form-item btnCode="004P000B002"  v-if="btnFlg[2]">
            <el-button type="primary"  @click="goodsChange">转货</el-button>
          </el-form-item>
          <el-form-item btnCode="004P000B003"  v-if="btnFlg[3]">
            <el-button type="primary" @click="takeGoods">提货</el-button>
          </el-form-item>
          <el-form-item btnCode="004P000B004"  v-if="btnFlg[4]">
            <el-button type="primary" @click="exportFn" :disabled="isDisable">导出</el-button>
          </el-form-item>
          <el-form-item btnCode="004P000B004"  v-if="btnFlg[5]">
            <el-button type="primary" @click="whqthFN" >无货权提货</el-button>
          </el-form-item>
           <el-form-item>
           <p class="margin0">已选重量：<span class="red">{{weight|numFormat(3)}}</span>吨</p>
          </el-form-item>
          <el-form-item>
           <p class="margin0">已选件数：<span class="red">{{num}}</span>件</p>
          </el-form-item>
           <el-form-item>
           <p class="margin0">总重量：<span class="red">{{allWeight}}</span>吨</p>
          </el-form-item>
          <el-form-item>
           <p class="margin0">总件数：<span class="red">{{total}}</span>件</p>
          </el-form-item>
          <!-- <el-form-item>
            <el-button type="primary" @click="">查看监控</el-button>
          </el-form-item> -->
          <!-- <el-form-item>
            <el-button  type="danger" @click="">挂牌交易</el-button>
          </el-form-item> -->
       </div>
      </el-form>
    </div>
    <!-- 表格 -->
    <div :style="{height:h}">
        <el-table :data="tableList"   ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
      class="table" height="100%" style="width: 100%" center :row-key="getRowKeys" border="" >
        <el-table-column type="selection" width="55" :reserve-selection="true" :selectable="selectable"></el-table-column>
        <el-table-column fixed type="index"  width="55" label="序号"></el-table-column>
        <!-- <el-table-column label="序号" type="index" width="55">
        <template scope="scope">
          <span>{{(searchFrom.pageNo - 1) * searchFrom.pageSize + scope.$index + 1}}</span>
        </template>
      </el-table-column> -->
       <el-table-column property="cargoBarcode" width="150" label="捆包号"></el-table-column>
        <el-table-column property="status" label="货物状态" >
          <template scope="scope">
            {{[ "正常", "锁定","加工中" ][scope.row.status]}}
          </template>
        </el-table-column>
        <el-table-column property="takeGoodStatus" label="操作状态" >
          <template scope="scope">
            {{[ "未操作", "转货中","提货中","暂存中"][scope.row.takeGoodStatus]}}
          </template>
        </el-table-column>
        <el-table-column property="productTypeName"  width="100" label="货物类型"></el-table-column>
        <el-table-column property="productName" width="100"  label="品名"></el-table-column>
        <el-table-column property="model" width="120" label="材质"></el-table-column>
        <el-table-column property="specification" width="120"  label="规格"></el-table-column>
        <el-table-column property="weight"  width="100" label="重量(吨)"></el-table-column>
        <el-table-column property="contractNumber" width="120"  label="合同号"></el-table-column>
        <el-table-column property="agreementNumber" width="130"  label="合约号"></el-table-column>
        <el-table-column property="cargoLocation" width="150"  label="货位"></el-table-column>
        <el-table-column property="organizationName" width="240" label="所在仓库"></el-table-column>
        <el-table-column property="instockDate" width="160"  label="入库时间"></el-table-column>
        <el-table-column property="unloadingSite" width="240"  label="流向"></el-table-column>
        <el-table-column property="stockDate" width="100"  label="库存天数"></el-table-column>
        <el-table-column prop="trimming"  min-width="150"  label="切边方式"></el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <wuHuoQuanTiHuo v-if="wuhuoquanFlag" :wuhuoquanFlag.sync="wuhuoquanFlag"></wuHuoQuanTiHuo>
</div>
</template>

<script>
import { getBtn, getAttribute } from '@/utils/getButton'
import { exportExcel } from '@/utils/fileDownXlsx.js'
// import axios from 'axios'
import { stockProductList, getDictionaryAll, warehouseList, addBill } from '@/api/soc-stock'
import { getOrganizationNameList } from '@/api/soc-stock-cosco'
import wuHuoQuanTiHuo from '@/views/soc-stock/inventory/wuHuoQuanTiHuo.vue'
export default {
  components: {
    wuHuoQuanTiHuo
  },
  data () {
    return {
      tableArr: [],
      getRowKeys (row) {
        return row.cargoId
      },
      h: '500px',
      weight: '0.00',
      num: 0,
      allWeight: 0,
      takegoodsDialog: false,
      entrustDialog: false,
      tableList: [],
      productTypes: [],
      warehouseList: [],
      loading: false,
      total: 0,
      zt: [
        { val: '', name: '请选择' },
        { val: 0, name: '正常' },
        { val: 1, name: '锁定' },
        { val: 2, name: '加工中' }
      ],
      searchFrom: {
        pageNo: 1,
        pageSize: 50,
        productType: ''
      },
      ids: [],
      selectedOptions: [],
      isDisable: false,
      wuhuoquanFlag: false,
      btnFlg: [],
      btnIdArr: ['004P000B000', '004P000B001', '004P000B002',
        '004P000B003', '004P000B004', '004M0H0100']
    }
  },
  created () {
    this.tableArr = getAttribute('ARRisJanfa')
    this.btnFlg = getBtn(this.btnIdArr, '/inventory')
    // 获取货物类型
    getDictionaryAll({ groupNo: 'product_type' }).then(res => {
      this.productTypes = res
      this.productTypes.unshift({ show_name: '请选择', item_no: '' })
    })
    if (localStorage.getItem('isCutCrm3') == 1) {
      this.warehouseList = [{
        relTenantName: localStorage.getItem('createTenantName'),
        relTenantCode: localStorage.getItem('createTenantCode')
      }]
      this.$set(this.searchFrom, 'organizationId', this.warehouseList[0].relTenantCode)
      this.getGoodsList(this.searchFrom)
    } else {
      getOrganizationNameList({
        userCode: localStorage.getItem('userCode'),
        tenantCode: localStorage.getItem('tenantCode')
      }).then(res => {
        this.warehouseList = res
        this.$set(this.searchFrom, 'organizationId', res[0].relTenantCode)
        this.getGoodsList(this.searchFrom)
      })
    }

    // warehouseList().then(res => {
    //   selectCommonDictionary({ groupName: 'organizationIds' }).then(res1 => {
    //     if (res1) {
    //       let arr = res.filter(item => item.tenantCode == res1)
    //       this.warehouseList = arr
    //       this.$set(this.searchFrom, 'organizationId', res1)
    //     } else {
    //       this.warehouseList = res
    //     }
    //     this.getGoodsList(this.searchFrom)
    //   })
    // })
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 165) + 'px'
  },
  methods: {
    // 无货权提货
    whqthFN () {
      this.wuhuoquanFlag = true
    },
    // 判断是否可选
    selectable (row, index) {
      // 只有正常状态跟未操作得可以提货转货（20220310新定）
      if (row.status != 0 || row.takeGoodStatus != 0) {
        return false
      } else {
        return true
      }
    },
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcode) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcode.split(/[(\r\n)\r\n]+/) }
      if (this.searchFrom.cargoBarcode == '') { this.searchFrom.cargoBarcodes = '' }
      if (this.searchFrom.specifications) {
        let arr = this.searchFrom.specifications.split(/[(\r\n)\r\n]+/)
        if (arr.length == 1) {
          this.searchFrom.specificationOne = arr.toString()
          delete this.searchFrom.specification
        } else {
          this.searchFrom.specification = arr
          delete this.searchFrom.specificationOne
        }
      }
      if (this.searchFrom.specifications == '') {
        delete this.searchFrom.specification
        delete this.searchFrom.specificationOne
      }
      if (this.searchFrom.instockDate) {
        this.searchFrom.instockDateStart = this.searchFrom.instockDate[0]
        this.searchFrom.instockDateEnd = this.searchFrom.instockDate[1]
      }
      this.$refs.table.clearSelection()
      this.getGoodsList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
      this.weight = 0
      var that = this
      selection.forEach(item => {
        that.weight = (that.weight * 1000 + item.weight * 1000) / 1000
      })
      this.num = selection.length
    },
    // 点击选中
    // handleRowClick (row, column, event) {
    //   this.$refs.table.toggleRowSelection(row)
    // },
    // 获取货物列表
    getGoodsList (searchFrom) {
      this.loading = true
      stockProductList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
        this.allWeight = res.map.allWeight
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getGoodsList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getGoodsList(this.searchFrom)
    },
    // 导出
    exportFn () {
      let from = JSON.parse(JSON.stringify(this.searchFrom))
      from.pageSize = 9999
      exportExcel(
        this.global.stockName + '/stockProduct/exportList',
        from,
        '货物信息'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 货权变更
    goodsChange () {
      const selectData = this.$refs.table.selection
      console.log(selectData)
      this.ids = []
      if (selectData.length < 1) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else {
        let isHQ = false

        if (selectData.length == 1) {
          if (selectData[0].status != 0 || selectData[0].takeGoodStatus != 0) {
            this.$alert('该状态不能进行转货操作', '系统提示')
            isHQ = false
            return true
          } else {
            this.ids.push(selectData[0].cargoId)
            isHQ = true
          }
          isHQ = true
        } else {
          selectData.some(item => {
            if (item.status != 0 || item.takeGoodStatus != 0) {
              this.$alert('该状态不能进行转货操作', '系统提示')
              isHQ = false
              return true
            } else {
              if (item.organizationId != selectData[1].organizationId) {
                this.$alert('请选择同一仓库的货物', '系统提示')
                isHQ = false
                return true
              } else {
                this.ids.push(item.cargoId)
                isHQ = true
              }
            }
          })
        }

        if (isHQ) {
          this.$router.push({ name: 'goodsChange', query: { ids: this.ids, weight: this.weight } })
        }
      }
    },
    // 自提货物
    takeGoods () {
      const selectData = this.$refs.table.selection
      this.ids = []
      if (selectData.length < 1) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else {
        let isHQ = false

        if (selectData.length == 1) {
          if (selectData[0].status != 0 || selectData[0].takeGoodStatus != 0) {
            this.$alert('该状态不能进行提货操作', '系统提示')
            isHQ = false
            return true
          } else {
            this.ids.push(selectData[0].cargoId)
            isHQ = true
          }
          isHQ = true
        } else {
          selectData.some(item => {
            if (item.status != 0 || item.takeGoodStatus != 0) {
              this.$alert('该状态不能进行提货操作', '系统提示')
              isHQ = false
              return true
            } else {
              if (item.organizationId != selectData[1].organizationId) {
                this.$alert('请选择同一仓库的货物', '系统提示')
                isHQ = false
                return true
              } else {
                this.ids.push(item.cargoId)
                isHQ = true
              }
            }
          })
        }
        if (isHQ) {
          this.$confirm('是否执行提货操作?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消'
          }).then(() => {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            addBill({ cargoIds: this.ids.toString(), organizationName: selectData[0].organizationName, organizationId: selectData[0].organizationId }).then(res => {
              loading.close()
              this.$router.push({ name: 'StakeGoodsBillJF' })
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          }).catch(() => {

          })
          // this.$router.push({ name: 'takeOperation', query: { ids: this.ids, weight: this.weight } })
        }
      }
    },
    closeDialog () {
      if (this.$refs.HQform !== undefined) {
        this.$refs.HQform.resetFields()
      }
      if (this.$refs.THform !== undefined) {
        this.$refs.THform.resetFields()
      }
      if (this.$refs.PHform !== undefined) {
        this.$refs.PHform.resetFields()
      }
      this.$refs.table.clearSelection()
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        instockDate: null
      }
      this.$set(this.searchFrom, 'organizationId', this.warehouseList[0].relTenantCode)
    }
  }
}
</script>

<style scoped lang='less'>
.searchBox{
  display: flex;
}
.inpBox .el-date-editor{
      width: 350px!important;
}
.gjhBox{
  display: flex;
}
/deep/.el-input.is-disabled .el-input__inner{
    border: none;
    background-color: #dcedff;
    color: #606266;
}
.dialogtnBox{
  display: flex;
  justify-content: space-between;
  /deep/.el-form-item--mini.el-form-item{
        margin-bottom: 15px!important;
  }

}
.zhong{
  /deep/.el-input__inner{
        width: 66px;
  }
  /deep/.el-input{
    width: auto;
  }
}

</style>
